import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';
import ProjectListPage from './pages/ProjectListPage';
import ProjectDetailPage from './pages/ProjectDetailPage';
import TaskListPage from './pages/TaskListPage';
import ProgressPage from './pages/ProgressPage';

import GanttPage from './pages/GanttPage';
import PendingRegistrationsPage from './pages/PendingRegistrationsPage';

const AppRouter = () => (
  <Router>
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route
        path="/projects"
        element={
          <PrivateRoute>
            <Layout>
              <ProjectListPage />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/projects/:id"
        element={
          <PrivateRoute>
            <Layout>
              <ProjectDetailPage />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/tasks"
        element={
          <PrivateRoute>
            <Layout>
              <TaskListPage />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/progress"
        element={
          <PrivateRoute>
            <Layout>
              <ProgressPage />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/gantt"
        element={
          <PrivateRoute>
            <Layout>
              <GanttPage />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/pending-registrations"
        element={
          <PrivateRoute>
            <Layout>
              <PendingRegistrationsPage />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route path="*" element={<LoginPage />} />
    </Routes>
  </Router>
);

export default AppRouter;
